import { UmbracoTypes } from '~/lib/data-contract';
import { useCampaignResults } from '~/services/loop54/hooks';
import { memo } from 'react';
import { CarouselWithItems } from './helpers';

function M30CampaignProductCarousel({
    amountOfProducts,
    campaignID,
    headline,
    link,
    sorting,
    ascendingOrder,
    onlyShowInStock,
}: Omit<UmbracoTypes.IM30CampaignProductCarouselModule, 'type'>) {
    const { data } = useCampaignResults({
        amountOfProducts,
        campaignID,
        sorting,
        ascendingOrder,
        onlyShowInStock,
    });

    return <CarouselWithItems data={data?.results?.items} headline={headline} link={link} />;
}

export default memo(M30CampaignProductCarousel);
